import React from "react";
import { RowCreateCallBackSpan } from "../../../../Constant";
import { ROW_CREATE_CALL } from "../../../../Data/DataTable/RowCreateCallbackData";
import { H3 } from "../../../../AbstractElements";

const RowCreateCallbackHeadrer = () => {
  return (
    <div className="card-header pb-0 card-no-border">
      <H3>{RowCreateCallBackSpan}</H3>
      {ROW_CREATE_CALL.map((item, index) => (
        <span key={index}>{item}</span>
      ))}
    </div>
  );
};

export default RowCreateCallbackHeadrer;
